<template>
  <div :style="wrapStyle" class="anchor-pos">
    <el-steps :direction="direction" :active="steps.length">
      <el-step
        v-for="step in steps"
        :key="step.key"
        :title="step.title"
        :description="step.description"
        class="cursor-pointer"
        @click.native="() => onStep(step.key)"
      />
    </el-steps>
  </div>
</template>

<script>
export default {
  props: {
    // 步骤条的方向，默认纵向
    direction: {
      type: String,
      default: 'vertical',
    },
    // 步骤条容器的内联样式
    wrapStyle: {
      type: Object,
      default: () => {
        return {
          height: '400px',
        };
      },
    },
    /**
     * 步骤条数据
     * 格式：[{title: '标题', key: '唯一索引', description: '描述'}]
     */
    steps: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    onStep(key) {
      this.$emit('anchor', key);
    },
  },
};
</script>

<style lang="scss" scoped>
.anchor-pos {
  border-right: 1px solid #DCDFE6;
}
</style>
